import React, { useState } from 'react'
import { getImages } from '../Common/const'
import { motion } from "framer-motion";
import UseScrollReveal from '../Common/UseScrollReveal';

const WeBuyExoticsSecond = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();
        const x = ((clientX - left) / width - 2) * 20;
        const y = ((clientY - top) / height - 1) * 20;
        const bgX = ((clientX - left) / width - 5) * 30;
        const bgY = ((clientY - top) / height - 0.5) * 30;
        setPosition({ x, y, bgX, bgY });
    };
    UseScrollReveal()
    return (
        <>
            <section className='wbe2-wrap pt-140'
                style={{
                    backgroundImage: `url(${getImages('wbe-hero-2.webp')})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                }}
            >
                <div className='d-flex align-items-center justify-content-between wbe2-flex'>
                    <div className='w-100'>
                        <h1 className='lg-title font-4-3em fw-700 text-uppercase mb-0 text-center wow reveal fadeInUp'>We Buy Exotics</h1>
                        <div className='mt-4 mb-4 text-center wow reveal fadeInUp'>
                            <a href='#' className='orange-white-btn fw-700 text-uppercase lg-btn w-330 d-inline-block'>Sell Your Exotic</a>
                        </div>
                        <div className='sm-title font-1-5em text-center wow reveal fadeInUp'><a href='tel:8135880905' className='text-white'>(813) 588-0905</a></div>
                    </div>
                </div>
            </section>
            <section className='wbe2-sell-exotic-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-xl-6 col-lg-5 text-center wbe2-exotic-image wow reveal fadeInLeft'>
                            <img src={getImages('we-buy-exotic-logo.png')} />
                        </div>
                        <div className='col-xl-6 col-lg-7 text-center web2-se-right wow reveal fadeInRight'>
                            <div className='lg-title text-start font-2-4em text-uppercase'>The Fastest & Safest <br />Way To Sell Your <br />Exotic Car</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='wbe-about-wrap wbe2-about-wrap'>
                <div className='container'>
                    <div className='row mlr-60'>
                        <div className='col-lg-6 mb-lg-0 mb-5 wow reveal fadeInLeft'>
                            <div className='wbe-about-image'>
                                <img src={getImages('we-know.webp')} />
                            </div>
                            <div className='md-title font-2-5em text-orange eurostile fw-400 text-uppercase mt-lg-5 mt-4 mb-lg-4 mb-3'>We know what to do!</div>
                            <div className='common-text'>
                                <p>Our team at We Buy Exotics are industry experts. We focus on purchasing vehicles over $100,000. We specialize in high end cars like Lamborghini, Ferrari, Porsche, Bentley, Mclaren, Aston Martin, Rolls Royce, Maserati, Mercedes, BMW, Range Rover, and many other sports cars or supercars. We have all worked for the biggest franchise car dealerships in the industry at the Ultra-Highline Level with roughly 20 plus years of experience each. We are experts in being able to form valuations on car prices with extreme accuracy.</p>
                                <p>EVERYONE knows how to buy their next car. However almost nobody knows how to sell their car, especially a Luxury or Exotic Car!</p>
                                <p>The typical paths are either selling to a private party or going to the dealer so the can consign on their showroom. These both can be great options if you have TIME to WASTE on potential buyers that want to come look at the car just for a test drive. And if you have a payoff or the new buyer needs a loan, that is a WHOLE other story. For more information read through our Complete How-To Sell Your Exotic Car Guide.</p>
                                <p>If you go to the dealer to sell your vehicle outright, they will likely not give you the true value of your car, their main goal is to sell you another new car. Or they’ll try to consign your car so they can list on autotrader so they can make profit with no risk on your luxury vehicles just so you can net the same amount you could have received initially!</p>
                            </div>
                        </div>
                        <div className='col-lg-6 wow reveal fadeInRight'>
                            <div className='wbe-about-image'>
                                <img src={getImages('ready-to-sell.webp')} />
                            </div>
                            <div className='md-title font-2-5em text-orange eurostile fw-400 text-uppercase mt-lg-5 mt-4 mb-lg-4 mb-3'>Are you ready to sell?</div>
                            <div className='common-text'>
                                <p>In today’s world, nobody will buy a car without running a Carfax, so why would anyone not make sure they’re receiving the highest offer they can for the trade?</p>

                                <p>The highline car market is a lot like the stock market, constant swings in prices based off supply & demand are changing every day. For the most part, if you’re looking to buy a car now, every day you can wait the better as typically the car will get cheaper. However, when selling, the same holds true, every day you wait to sell your car typically the value will continue to depreciate and the more you can lose.</p>

                                <p>We encourage every one of our clients who are seriously ready to sell their car to call 5 other car dealers or car buyers and see what they’ll “write a check” for their vehicle TODAY and then contact us as we feel confident we can offer more. It’s an extremely SIMPLE transaction, you sell your car and we buy it, typically within less than 24 hours. We even buy leased cars. This will be the EASIEST CAR DEAL you’re ever done!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='book-appointment-wrap'>
                <div className="mouse-container"
                    onMouseMove={handleMouseMove}>
                    <motion.div
                        className="mouse-background"
                        style={{
                            background: `url(${getImages('wbe2-ready-to-sell.webp')}) no-repeat center/cover`
                        }}
                        animate={{
                            x: position.bgX,
                            y: position.bgY,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    />

                    <div className='w-100 text-center mouse-text'>
                        <div className='container'>
                            <div className='banner-lg-title font-3-5em text-uppercase wow reveal fadeInUp'>Are you ready to sell?</div>
                            <div className="my-4 wow reveal fadeInUp">
                                <button type="button" className="orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase">Sell Your Exotic</button>
                            </div>
                            <div className='text-center wow reveal fadeInUp'>
                                <a href='tel:8135880905' className='sm-title font-1-5em fw-400 avenir-next text-white'>
                                    Or Call (813) 588-0905
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WeBuyExoticsSecond